/* eslint-disable */
let isScriptLoaded = false;
let isScriptLoading = false;

export const loadGoogleMapsScript = async (secretValues:any): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (isScriptLoaded) return resolve();

    if (isScriptLoading) {
      const interval = setInterval(() => {
        if (window.google?.maps) {
          clearInterval(interval);
          isScriptLoaded = true;
          resolve();
        }
      }, 100);
      return;
    }

    isScriptLoading = true;

    const script = document.createElement('script');
    script.src =
      `https://maps.googleapis.com/maps/api/js?key=${secretValues?.googleMapsKey}&libraries=places`;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      isScriptLoaded = true;
      resolve();
    };

    script.onerror = (err) => reject(err);

    document.body.appendChild(script);
  });
};
